import * as types from '../const/action.types';
import { get, put, post, del } from '../api/_basic';

export function allProducts() {
    return async (dispatch) => {
        dispatch(productsHasErrored(false, ''));
        dispatch(productsIsLoading(true));
        return get(`${process.env.REACT_APP_API_PRODUCT}`)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                get(`${process.env.REACT_APP_API}/estacion`)
                    .then((response) => {
                        dispatch(productsIsLoading(false));
                        if (response.error !== undefined) {
                            throw Error(response);
                        }
                        return response;
                    })
                    .then((workstations) => {
                        dispatch(productsHasErrored(false, ''));
                        dispatch(loadWorkStationSuccess(workstations));
                    })
                    .catch((error) => {
                        dispatch(productsIsLoading(false));
                        dispatch(productsHasErrored(error.type ? error.type : true, error.message));
                    });
                dispatch(loadProductsSuccess(items));
            })
            .catch((error) => {
                dispatch(productsIsLoading(false));
                dispatch(productsHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function addProduct(product) {
    return async (dispatch) => {
        dispatch(productIsSaving(true));
        return post(`${process.env.REACT_APP_API_PRODUCT}`, product)
            .then((response) => {
                dispatch(productIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function wasteProduct(product) {
    return async (dispatch) => {
        dispatch(productsIsLoading(true));
        return post(`${process.env.REACT_APP_API_WASTE}`, product)
            .then((response) => {
                dispatch(productsIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                dispatch(productsIsLoading(false));
                throw error;
            });
    };
}

export function editProduct(product) {
    return async (dispatch) => {
        dispatch(productIsSaving(true));
        return put(`${process.env.REACT_APP_API_PRODUCT}/${product.id}`, product)
            .then((response) => {
                dispatch(productIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response.data;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function duplicateProduct(product) {
    return async (dispatch) => {
        dispatch(productsIsLoading(true));
        var p1 = new Promise((resolve, reject) => {
            resolve(get(`${process.env.REACT_APP_API}/familiaproducto`));
        });
        var p2 = new Promise((resolve, reject) => {
            resolve(get(`${process.env.REACT_APP_API}/unidadmedida`));
        });
        var p3 = new Promise((resolve, reject) => {
            resolve(get(`${process.env.REACT_APP_API}/estacion`));
        });
        var p4 = new Promise((resolve, reject) => {
            resolve(get(`${process.env.REACT_APP_API_PRODUCT}/${product}`));
        });
        var p5 = new Promise((resolve, reject) => {
            resolve(get(`${process.env.REACT_APP_API}/tipomaquina`));
        });

        Promise.all([product ? p4 : null, p1, p2, p3, p5])
            .then((values) => {
                const product = values[0] ? values[0] : {};
                product._families = values[1];
                product._units = values[2];
                product._workStations = values[3];
                product._machinetypes = values[4];
                return product;
            })
            .then((item) => {
                post(`${process.env.REACT_APP_API_PRODUCT}`, item)
                    .then((response) => {
                        dispatch(productIsSaving(false));
                        if (response.error !== undefined) {
                            throw Error(response);
                        }
                        dispatch(productsIsLoading(false));
                        dispatch(allProducts());
                        return true;
                    })
                    .catch((error) => {
                        throw error;
                    });
            })
            .catch((error) => {
                dispatch(productsIsLoading(false));
                throw error;
            });
    };
}

export function deleteProduct(product) {
    return async (dispatch) => {
        dispatch(productsIsLoading(true));
        return del(`${process.env.REACT_APP_API_PRODUCT}/${product}`)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                dispatch(productsIsLoading(false));
                dispatch(allProducts());
                return true;
            })
            .catch((error) => {
                dispatch(productsIsLoading(false));
                console.log(error);
                throw error;
            });
    };
}

export function getMachinesProduct(local, product) {
    return async (dispatch) => {
        return get(`${process.env.REACT_APP_API_LOCAL}/${local}/producto/${product}/maquinas`)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return items;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function loadProduct(product) {
    return async function(dispatch) {
        dispatch(productsHasErrored(false, ''));
        dispatch(productsIsLoading(true));
        dispatch(loadProductSuccess({}));

        var p1 = new Promise((resolve, reject) => {
            resolve(get(`${process.env.REACT_APP_API}/familiaproducto`));
        });
        var p2 = new Promise((resolve, reject) => {
            resolve(get(`${process.env.REACT_APP_API}/unidadmedida`));
        });
        var p3 = new Promise((resolve, reject) => {
            resolve(get(`${process.env.REACT_APP_API}/estacion`));
        });
        var p4 = new Promise((resolve, reject) => {
            resolve(get(`${process.env.REACT_APP_API_PRODUCT}/${product}`));
        });
        var p5 = new Promise((resolve, reject) => {
            resolve(get(`${process.env.REACT_APP_API}/tipomaquina`));
        });

        Promise.all([product ? p4 : null, p1, p2, p3, p5])
            .then((values) => {
                const product = values[0] ? values[0] : {};
                product._families = values[1];
                product._units = values[2];
                product._workStations = values[3];
                product._machinetypes = values[4];
                return product;
            })
            .then((item) => {
                dispatch(productsHasErrored(false, ''));
                dispatch(loadProductSuccess(item));
                dispatch(productsIsLoading(false));
            })
            .catch((error) => {
                dispatch(productsHasErrored(error.type ? error.type : true, error.message));
                dispatch(productsIsLoading(false));
            });
    };
}

export function loadProductSuccess(data) {
    return {
        type: types.LOAD_PRODUCT_SUCCESS,
        data,
    };
}

export function loadWorkStationSuccess(data) {
    return {
        type: types.LOAD_WORKSTATION_SUCCESS,
        data,
    };
}

export function loadProductsSuccess(data) {
    return {
        type: types.PRODUCTS_SUCCESS,
        data,
    };
}

export function productsHasErrored(bool, message) {
    return {
        type: types.PRODUCTS_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function productsIsLoading(bool) {
    return {
        type: types.PRODUCTS_IS_LOADING,
        isLoading: bool,
    };
}

export function productIsSaving(bool) {
    return {
        type: types.PRODUCTS_IS_SAVING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/product.actions.js